import { GraphQLCampaign } from 'modules/campaigns/lib';
import { CampaignState } from 'modules/domains/campaign';

export const getChangeCampaignStatePayload = (
  campaign: GraphQLCampaign,
  campaignState: CampaignState,
) => {
  const { id: campaignId } = campaign;

  return {
    campaignId,
    campaignState,
  };
};
